
import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface DataPoint {
  [key: string]: string | number;
}

interface Props {
  data: DataPoint[];
  title: string;
  xAxisKey: string;
  yAxisKey: string;
  color?: string;
  height?: number;
  yAxisFormatter?: (value: number) => string;
  fullWidth?: boolean;
}

const GenericAreaChart: React.FC<Props> = ({
  data,
  title,
  xAxisKey,
  yAxisKey,
  color = "#8b5cf6",
  height = 250,
  yAxisFormatter,
  fullWidth = false,
}) => {
  const gradientId = `color-${color.replace("#", "")}`;

  return (
    <div className={`chart-card ${fullWidth ? "full-width" : ""}`}>
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={data}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} />
              <stop offset="95%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey={xAxisKey} stroke="#6b7280" />
          <YAxis
            stroke="#6b7280"
            tickFormatter={yAxisFormatter}
          />
          <Tooltip />
          <Area
            type="monotone"
            dataKey={yAxisKey}
            stroke={color}
            fill={`url(#${gradientId})`}
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GenericAreaChart;